import { TagsServiceBackend } from "@serviceBackends";
import { CategoriaFiltroDTO, TagDTO, TagInfoDTO } from "@DTOS";
import { Injectable } from "@angular/core";

import "@extensiones";

@Injectable({
    providedIn: "root"
})
export class TagsService {
    constructor(private tagsServiceBackend: TagsServiceBackend) {}

    public async obtenerCategorias(): Promise<CategoriaFiltroDTO[]> {
        return await this.tagsServiceBackend.getCategorias();
    }

    public async obtenerTags(): Promise<TagDTO[]> {
        return await this.tagsServiceBackend.getTags();
    }

    public async agregarTagType(categoriaFiltro: CategoriaFiltroDTO): Promise<CategoriaFiltroDTO> {
        return await this.tagsServiceBackend.agregarTagType(categoriaFiltro);
    }

    public async agregarTag(tag: TagDTO): Promise<TagDTO> {
        return await this.tagsServiceBackend.agregarTag(tag);
    }

    public async modificarTag(tag: TagDTO): Promise<TagDTO> {
        return await this.tagsServiceBackend.modificarTag(tag);
    }

    public async obtenerTagInfo(tagDTO: TagDTO): Promise<TagInfoDTO> {
        return await this.tagsServiceBackend.getTagInfo(tagDTO.id);
    }
}
